<template>
  <el-form-item
    :label="attrOption.label"
    :prop="attrOption.prop"
  >
    <el-select
      v-model="customerNameId"
      v-bind="attrOption"
    >
      <el-option
        v-for="item in attrOption.options.list"
        :key="'option' + item[attrOption.options.value]"
        :label="item[attrOption.options.label]"
        :value="item[attrOption.options.value]"
      >
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  data() {
    return {
      // eslint-disable-next-line vue/no-unused-properties
      defaultOption: { remote: true, filterable: true, clearable: true },
      attrOption: {},
    }
  },
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    model: {
      type: [String, Number],
      default: '',
    },
  },
  watch: {
    $attrs: {
      handler(val) {
        this.attrOption = {
          ...this.defaultOption,
          ...val,
        }
      },
      deep: true,
    },
  },
  computed: {
    customerNameId: {
      set(val) {
        this.$emit('change', val)
      },
      get() {
        return this.model
      },
    },
  },
  created() {
    this.attrOption = {
      ...this.defaultOption,
      ...this.$attrs,
    }
  },
}
</script>

<style lang="scss" scoped>
.customerTips {
  color: #2e7eff;
  cursor: pointer;
  margin-left: 20px;
}
</style>
